export default {
  agents(state, data) {
    state.agents = data;
  },
};
